import { GameRangeFilterOption, GameType, PeriodRange, TranslatedOption } from '@statsbomb/parachute-types';

export const convertGameFilterValuesToPersistedValues = ({
  periodRangeToConvert,
  gameRangeToConvert,
  gameTypeToConvert,
}: {
  periodRangeToConvert: PeriodRange;
  gameRangeToConvert: GameRangeFilterOption;
  gameTypeToConvert: TranslatedOption<GameType>;
}) => ({
  periodRange: { value: periodRangeToConvert.value },
  gameType: gameTypeToConvert.value,
  gameRange: gameRangeToConvert.key,
});
